import { openWatchListGroupDialog , openWatchlistContextMenu} from '@/actions/app';
import { Icons }                                         from '@/configurations';
import { WATCHLIST_DIALOG_ACTION }                       from '@/constants/app';
import React                                             from 'react';
import {openMarketSetDialog} from '@/actions/app/dialog.action'

export const WatchlistHelper = {
  getTabHeader,
  convertItemsToString,
}

function getTabHeader(favoriteWatchlist = [], preDefinedWatchlist = [], options = {}, functions, startIndex = "", currentTab = '-1') {
  const { position, addIcon, removeIcon,editIcon,removeState,addState ,subTabValue} = options
  const { handleOpenDelete,handleAddButton,handleDeleteButton,handleOpenAddButton ,handleRefreshTable,handleChangeSubTab} = functions
  let positionWL = [], defaultWL = [], favoriteWL = [], iconWL = [], buttonWL = []
  if(position) {
    const id = `${startIndex}0`
    positionWL = [ {
      id: `${startIndex}1`, title: 'common_position', value:'position' ,isActive: `${startIndex}1` === currentTab
    },
    {
      id: `${startIndex}2`, title: 'market_all', value:'' ,isActive: `${startIndex}2` === currentTab
    },
    {
      id: `${startIndex}3`, title: 'market_hkex', value:'HKEX',isActive: `${startIndex}3` === currentTab
    },
    {
      id: `${startIndex}4`, title: 'market_usex', value:'USEX',isActive: `${startIndex}4` === currentTab
    },
    {
      id: `${startIndex}5`, title: 'market_stock_connect', value:'CN',isActive: `${startIndex}5` === currentTab
    },
    {
      id: `${startIndex}6`, title: 'common_funds', value:'FUND', isActive: `${startIndex}6` === currentTab
    },
  ]
  }
  // if(Array.isArray(preDefinedWatchlist)) {
  //   defaultWL = preDefinedWatchlist.reduce((acc, tmp, index) => {
  //     const id = `${startIndex}${index + 1}`
  //     acc.push({
  //       id,
  //       title: tmp.title,
  //       name: tmp.name,
  //       category: "P",
  //       isActive: id === currentTab,
  //     })
  //     return acc
  //   }, [])
    // defaultWL = [
    //   { id: `${startIndex}1`, title: 'HSX', isActive: `${startIndex}1` === currentTab },
    //   { id: `${startIndex}2`, title: 'HNX', isActive: `${startIndex}2` === currentTab },
    //   { id: `${startIndex}3`, title: 'UPCOM', isActive: `${startIndex}3` === currentTab },
    //   { id: `${startIndex}4`, title: 'Derivative', isActive: `${startIndex}4` === currentTab },
    // ]
  // }
  if(Array.isArray(favoriteWatchlist)) {
    favoriteWL = favoriteWatchlist.reduce((acc, tmp, index) => {
      const id = `${startIndex}${index + positionWL.length + 1}`
      acc.push({
        id,
        title: tmp.title,
        isActive: id === currentTab,
        name: tmp.name,
        category: "C",
        // handleOpenContextMenu: tmp['is_title_editable'] === 'Y'
        //     ? (position) => openWatchlistContextMenu(position, (menu) => handleClickContextMenu(menu, tmp)) : () => {},
      })
      return acc
    }, [])
  }
  const countId = positionWL.length + favoriteWL.length
  if(removeState){
    positionWL = []
    favoriteWL = [] 
    buttonWL = [ { id: `${startIndex}1`, value:'deleteButton',title:'common_button_delete',
    style:{backgroundColor:'#1780c2',color:'#fff',textAlign:"center",lineHeight:'0px',width:'60px',borderRadius:"2px"},
    handleClick:handleDeleteButton } ]
  }
  if(addState){
    positionWL = []
    favoriteWL = []
    buttonWL = [ { id: `${startIndex}1`, value:'addButton',title:'market_add_to_watchlist',
    style:{backgroundColor:'#1780c2',color:'#fff',textAlign:"center",lineHeight:'0px',width:'115px',borderRadius:"2px"},
    handleClick:handleAddButton } ]
  }
  if(addIcon) {   // () => openWatchListGroupDialog('watchlist_add', WATCHLIST_DIALOG_ACTION.CREATE) 
    iconWL.push({ id: `${startIndex}${countId + 1}`, icon: <Icons.Plus  color={addState ? '#1996e3' : ''}  title="plus"/> , handleClick: handleOpenAddButton})
  }
  if(removeIcon) {
    iconWL.push({ id: `${startIndex}${countId + 2}`, icon: <Icons.WatchlistDelete color={removeState ? '#1996e3' : '' } title="remove"/>, handleClick: handleOpenDelete  })
  }
  if(editIcon){
    iconWL.push({id:`${startIndex}${countId + 3}`,icon: <Icons.Edit title='edit'/>,handleClick:removeState ? ()=>{} : addState ? ()=>{} : () =>openMarketSetDialog(handleRefreshTable,subTabValue,handleChangeSubTab)})
  }
  return [...positionWL, ...defaultWL, ...favoriteWL,...buttonWL, ...iconWL]
}


function handleClickContextMenu(menu, wl) {
  switch (menu) {
    case 'watchlist_rename':
      openWatchListGroupDialog('watchlist_edit', WATCHLIST_DIALOG_ACTION.EDIT, wl);
      break;
    case 'watchlist_delete_group':
      openWatchListGroupDialog('watchlist_delete_group', WATCHLIST_DIALOG_ACTION.DELETE, wl);
      break;
    default:
      break;
  }
}

// function convertItemsToString1(items, newItem, isAdd) {
//   let isNewItem = true
//   const list = items.reduce((acc, item) => {
//     if(item.id === newItem.id && item.market === newItem.market) {
//       isNewItem = false
//       if(isAdd) {
//         acc.push(`${item.id}:${item.market}`)
//       }
//     } else {
//       acc.push(`${item.id}:${item.market}`)
//     }
//     return acc
//   }, [])
//   if(newItem && isAdd && isNewItem) {
//     list.push(`${newItem.id}:${newItem.market}`)
//   }
//   return list.join(',')
// }

function convertItemsToString(items, newItem, isAdd) {
  let isNewItem = true
  const list = items.reduce((acc, item) => {
    let isRemove = false
    if(newItem && item.id === newItem.id && item.market === newItem.market) {
      isNewItem = false
      isRemove = !isAdd
    }
    if(!isRemove) {
      acc.push(`${item.id}:${item.market}`)
    }
    return acc
  }, [])
  if(newItem && isAdd && isNewItem) {
    list.push(`${newItem.id}:${newItem.market}`)
  }
  return list.join(',')
}